import React, { useState } from 'react';
import { Colors, Text, SizeableRoundedDialog } from 'library';
import { Grid } from '@material-ui/core';
import ReferralMethodChoice from './ReferralMethodChoice';
import { emptyProvider } from './models';
import { getOneTimeGiftCardCopy } from './referralCopy';
import Celebrate from '../../../assets/icons/tandempay/tada-circle.svg';
import { useUserContext } from 'UserContext';

function getOneTimeOnlyBanner() {
    return (
        <Grid
            container
            item
            direction="row"
            justify="space-around"
            xs={12}
            style={{
                backgroundColor: Colors.turquoise,
                paddingTop: 5,
                paddingBottom: 5,
            }}
        >
            {oneTimeOnlyText()}
            {separatorText()}
            {oneTimeOnlyText()}
            {separatorText()}
            {oneTimeOnlyText()}
        </Grid>
    );
}

function separatorText() {
    return (
        <Text
            bold
            variant={'body1'}
            textStyle={{
                color: Colors.white,
                textAlign: 'center',
                display: 'inline-flex',
            }}
        >
            •
        </Text>
    );
}

function oneTimeOnlyText() {
    return (
        <Text
            bold
            variant={'body1'}
            textStyle={{
                color: Colors.white,
                textAlign: 'center',
                display: 'inline-flex',
            }}
        >
            ONE TIME ONLY
        </Text>
    );
}

const OneTimeGiftCard = ({
    referralContext,
    open,
    onClose,
    promoStep,
    setPromoStep,
}: {
    referralContext: string;
    open: boolean;
    onClose: () => void;
    promoStep: string;
    setPromoStep: (x: string) => void;
}) => {
    const [message, setMessage] = useState(getOneTimeGiftCardCopy());
    const { user } = useUserContext();

    function getContent() {
        if (promoStep === 'success') {
            return (
                <Grid style={{ marginRight: 48, marginLeft: 48, marginBottom: 20 }}>
                    <Celebrate height={135} width={150} style={{ marginBottom: 30 }} />
                    <Text variant={'h1'} textStyle={{ marginBottom: 24, fontFamily: 'PT Serif' }}>
                        Your gift card has been sent!
                    </Text>
                    <Text variant={'body1'}>
                        We appreciate you sharing the gift of Tandem. Have more friends who could use care? You'll each
                        receive $20 when they sign up with your referral code
                        {!!user?.referral_code ? ` ${user.referral_code}.` : '.'}
                    </Text>
                </Grid>
            );
        }
        return (
            <Grid>
                {getOneTimeOnlyBanner()}
                <Grid style={{ marginRight: 48, marginLeft: 48 }}>
                    <Text
                        variant={'h1'}
                        textStyle={{
                            fontFamily: 'PT Serif',
                            fontSize: 32,
                            marginBottom: 24,
                            marginTop: 24,
                            lineHeight: 1,
                        }}
                    >
                        Send a $40 Tandem gift card for free!
                    </Text>
                    <Text variant={'body2'}>
                        Give the gift of care for free. But hurry, this exclusive offer is only available for a limited
                        time.
                    </Text>
                    <Grid style={{ marginTop: 24 }}>
                        <ReferralMethodChoice
                            message={message}
                            referredProvider={emptyProvider}
                            setMessage={setMessage}
                            url={''}
                            referralContext={`${referralContext}: One Time Gift Card Modal`}
                            availableMethods={['email', 'text']}
                            promo={'OneTimeGiftCard'}
                            setPromoStep={setPromoStep}
                        />
                    </Grid>
                </Grid>
                {getOneTimeOnlyBanner()}
            </Grid>
        );
    }

    return (
        <SizeableRoundedDialog
            open={open}
            onClose={onClose}
            closeButton={true}
            style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12, maxWidth: 700 }}
        >
            {getContent()}
        </SizeableRoundedDialog>
    );
};

export default OneTimeGiftCard;
